import * as actionTypes from "./actionTypes";

export const toggleMenu = () => {
  return {
    type: actionTypes.TOGGLE_MENU,
  };
};
